import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { DataService } from 'src/app/@core/services/data.service';

@Component({
  selector: 'app-editor-custom-component-aulas-rapidas-sessao-dialog',
  templateUrl: 'dialog.component.html',
})
export class AulasRapidasSessaoDialogComponent implements OnInit {

  loading: boolean;
  sessions: string;
  session: string;

  constructor(
    public dialogRef: MatDialogRef<AulasRapidasSessaoDialogComponent>,
    public dataService: DataService
  ) {
    this.loading = true;
  }

  ngOnInit(): void {
    this.getSessions();
  }

  getSessions() {
    this.dataService.trailSessao(9)
      .subscribe((response: any) => {
        this.loading = false;
        this.sessions = response;
      });
  }

  selectSession(session: any) {
    this.dialogRef.close(session);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
